/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GetDocumentSitesResponseDataFromJSON, GetDocumentSitesResponseDataToJSON } from './GetDocumentSitesResponseData';
export function GetDocumentSitesResponseFromJSON(json) {
    return GetDocumentSitesResponseFromJSONTyped(json, false);
}
export function GetDocumentSitesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : GetDocumentSitesResponseDataFromJSON(json['data'])
    };
}
export function GetDocumentSitesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: GetDocumentSitesResponseDataToJSON(value.data)
    };
}
